import React, { useCallback, useEffect } from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import QuestionInput from '../components/Quiz/QuestionInput';
import AnswersInput from '../components/Quiz/AnswersInput';
import TrueAnswerSelect from '../components/Quiz/TrueAnswerSelect';
import { useRecoilState, useRecoilValue } from 'recoil';
import { authenticated } from '../recoil/auth';
import { quizInput, quizLoading, quizMessage } from '../recoil/quiz';
import { domainWeb } from '../config/constants';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import WaitingText from '../components/WaitingText';

const QuizDetailPage = () => {
  const { quizId } = useParams();
  const auth = useRecoilValue(authenticated);
  const [loading, setLoading] = useRecoilState(quizLoading);
  const [input, setInput] = useRecoilState(quizInput);
  const [message, setMessage] = useRecoilState(quizMessage);

  const middleLink = {
      label: "Kuis",
      route: "/quizzes"
  };

  const getQuizDetail = useCallback(async () => {
    setLoading(true);
    setMessage({});
    try {
        let url = `${domainWeb}/quizzes/${quizId}`;
        let response = await axios.get(url, 
            {headers: {
                'Content-Type': 'application/json', 
                'Accept': 'application/json', 
                'Authorization': 'Bearer ' + auth.token
            }},
        );
        setInput({
            question: response.data.question,
            answers: response.data.answers,
            true_answer: response.data.true_answer,
        });
        setLoading(false);
    } catch (error) {
        setLoading(false);
        console.error(error);
        setMessage({
          success: false,
          text: error,
        });
    }
  }, [auth.token, quizId, setLoading, setMessage, setInput]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({});
    try {
      let url = `${domainWeb}/quizzes/${quizId}`;
      let validation = validationInput();
      if (validation.success) {
        await axios.put(url, input, 
          {headers: {
            'Content-Type': 'application/json', 
            'Accept': 'application/json', 
            'Authorization': 'Bearer ' + auth.token
          }},  
        );
        setMessage({
          success: true,
          text: 'Berhasil Ubah Data Kuis',
        });
      } else {
        setMessage(validation);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setMessage({
        success: false,
        text: error,
      });
      setLoading(false);
    }
  }

  const validationInput = () => {
    if (input.question === '') {
      return {
        success: false,
        text: 'Soal tidak boleh kosong!',
      }
    }
    if (input.answers.length < 2) {
      return {
        success: false,
        text: 'Jawaban tidak boleh kurang dari 2!',
      }
    }
    if (input.true_answer === undefined || input.true_answer === '') {
      return {
        success: false,
        text: 'Jawaban benar belum dipilih!',
      }
    }
    return {
      success: true,
      text: ''
    }
  }

  const loadMessage = () => {
    if (message.success) {
      return <div className="mt-3 text-green-500">{message.text}</div>;
    } else {
      return <div className="mt-3 text-red-500">{message.text}</div>;
    }
  }

  useEffect(() => {
    document.title = 'Detail Kuis - Admin Hi Nano';
    getQuizDetail();
    setInput({
        question: '',
        answers: [],
      });
  }, [getQuizDetail, setInput]);

  return (
      <div className="flex min-h-screen bg-slate-100">
          <Sidebar />
          <div className="flex-1 p-10 ml-28">
              <Header title="Detail Soal" middle={middleLink} />
              <div className="w-2/3 px-8 py-5 bg-white rounded-lg shadow">
                  <h3 className="flex items-center gap-3 text-xl font-semibold">Detail Soal Kuis</h3>
                  {message.text === undefined || loadMessage()}
                  <form onSubmit={handleSubmit} action="">
                      <div className="flex flex-col flex-1 gap-8 mt-5">
                          <QuestionInput />
                          <AnswersInput />
                          { input.answers.length === 0 || <TrueAnswerSelect /> }
                          <div className="my-3">
                              {
                                loading
                                ? <button type="button" className="gap-3 px-5 py-3 text-center text-white bg-blue-600 rounded-lg shadow hover:bg-blue-700 shadow-blue-100">
                                      <WaitingText />
                                  </button>
                                : <button type="submit" className="gap-3 px-5 py-3 text-center text-white bg-blue-600 rounded-lg shadow hover:bg-blue-700 shadow-blue-100">
                                      <span>Simpan Perubahan</span>
                                  </button>
                              }
                            </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  )
}

export default QuizDetailPage